import React from 'react';
import {
  codeCooldown,
  getAccessToken,
  isMobileClient,
  setAccessToken,
  validatePhone,
} from '../../utils/CommonUtil';
import Mobile from './Mobile';
import PC from './PC';
import { getFileInfo, getPreviewConfig, SMSSendType } from '../../api/FileApi';
import { FileInfoBO } from '../../model/BO/FileBO';
import { RequestStatus } from '../../model/BO/CommonBO';
import { getQuery, getUrlLast } from '../../utils/UrlUtil';
import { getFileTypeByName, getFileType } from '../../utils/FileUtil';
import {
  downloadFile,
  openPreviewFile,
  registerCheckRequest,
  registerCodeRequest,
  registerSkipStep,
  resendSMSLoginCode,
  sms2Login,
} from '../../service/FileService';
import { SizeMB, supportEdit, supportPreview } from '../../constants/commonConstants';
import { parseAccessToken } from '../../utils/DateUtil';
import { Button, Input, message, Select, Tooltip } from 'antd';
import './index.scss';
interface ShareState {
  fileInfo: FileInfoBO | null;
  fetchStatus: RequestStatus;
  shareOpenId: string;
  allowPreview: boolean;
  previewDomain: string;
  noPermission: boolean;
  notQtClient: boolean;
  mobileValue: string;
  codeValue: string;
  loading: boolean;
  canGetCode: boolean;
  validationBtnTxt: string;
  currentMobileNotQtUser: boolean; // 当前sms登录手机号是否是轻推用户
}
const { Option } = Select;

export default class PublicShare extends React.PureComponent<any, ShareState> {
  constructor(props: any) {
    super(props);
    this.state = {
      fileInfo: null,
      fetchStatus: RequestStatus.FINISH,
      shareOpenId: '',
      allowPreview: false,
      previewDomain: '',
      noPermission: false,
      notQtClient: false,
      mobileValue: '',
      codeValue: '',
      loading: false,
      canGetCode: true,
      validationBtnTxt: '获取验证码',
      currentMobileNotQtUser: true,
    };
    this.loadData = this.loadData.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handlePreview = this.handlePreview.bind(this);
  }
  public initPageData = () => {
    let shareOpenId = getUrlLast(window.location.href);
    if (window.location.href.indexOf('?') !== -1) {
      shareOpenId = window.location.pathname.slice(
        window.location.pathname.lastIndexOf('/') + 1,
        window.location.pathname.length
      );
    }
    if (getQuery('accessToken')) {
      setAccessToken(getQuery('accessToken') || '');
    }
    const localToken = getAccessToken();
    if (localToken) {
      const expire = parseAccessToken(localToken).expires;
      if (Date.now() > expire * 1000) {
        // token过期则清空本地token
        // setAccessToken('');
        // alert('token过期了' + localToken);
      }
    }
    if (window.location.pathname.indexOf('no-auth') !== -1) {
      this.setState({
        noPermission: true,
      });
      return;
    }
    if (shareOpenId && window.location.pathname.indexOf('no-auth') < 0) {
      this.setState(
        {
          shareOpenId,
        },
        () => this.loadData()
      );
    }
  };
  public componentDidMount() {
    document.title = '文档共享';
    if (isMobileClient() && navigator.userAgent.toLocaleLowerCase().indexOf('qingtui') < 0) {
      this.setState({
        notQtClient: true,
      });
      if (getQuery('accessToken') || getAccessToken()) {
        // 如果是非轻推客户端打开且已经短信登录获取了token 或者本地有token
        this.initPageData();
      }
    } else {
      this.initPageData();
    }
  }

  public async loadData() {
    this.setState({ fetchStatus: RequestStatus.PENDING });
    try {
      const fileInfo = await getFileInfo(this.state.shareOpenId);
      if (fileInfo.scanUrl) {
        // 如果有扫码登录的url 则说明需要先扫码登录才能操作本页面
        window.location.href = fileInfo.scanUrl;
        return;
      }
      const previewConfig = await getPreviewConfig();
      const supports = supportEdit || [];
      const type = getFileType(fileInfo.fileName);
      let preview = false;
      if (
        supports.findIndex((item) => item.trim() === type.toLowerCase()) > -1 &&
        previewConfig.fileLimitSize * SizeMB >= fileInfo.size
      ) {
        preview = true;
      }
      document.title = fileInfo.fileName;
      if (!fileInfo || !fileInfo.fileName) {
        document.title = '文档共享';
      }
      const isMobile = isMobileClient();
      this.setState(
        {
          fileInfo,
          fetchStatus: RequestStatus.FINISH,
          allowPreview: preview,
          previewDomain: window.location.origin || '',
        },
        () => {
          if (this.state.allowPreview && !isMobile) {
            this.handlePreview();
          }
        }
      );
    } catch (e) {
      if (String(e.code) === '50012' || String(e.code) === '46038') {
        this.setState({
          noPermission: true,
          fetchStatus: RequestStatus.FINISH,
        });
      } else {
        this.setState({
          noPermission: true,
          fetchStatus: RequestStatus.FAILED,
        });
      }
    }
  }

  public isSupportsByFileName = (fileName: string) => {
    let type = 'file';
    let upperType = 'file';
    if (fileName) {
      // 没有扩展名直接不能预览
      const index = fileName.lastIndexOf('.');
      if (index === -1) {
        return false;
      }
      const filePop = fileName.split('.').pop();
      if (filePop && filePop.length >= 2) {
        type = filePop.toLowerCase();
        upperType = filePop.toUpperCase();
      }
    }
    const types = supportPreview;
    return types.indexOf(type) < 0 && types.indexOf(upperType) < 0 ? false : true;
  };

  public handleDownload() {
    if (this.state.fileInfo) {
      if (isMobileClient()) {
        const cInfo = (window as any).qt.getClientInfo();
        if (
          cInfo &&
          cInfo.type === 'ios' &&
          !this.isSupportsByFileName(this.state.fileInfo.fileName)
        ) {
          (window as any).qt.toast({
            content: '手机下载后无法打开此文件，请使用其他设备下载查看。',
            icon: 2,
            time: 3000,
          });
        } else {
          downloadFile(this.state.fileInfo.fileId, this.state.fileInfo.domainId);
        }
      } else {
        downloadFile(this.state.fileInfo.fileId, this.state.fileInfo.domainId);
      }
    }
  }

  public handlePreview() {
    openPreviewFile(
      this.state.previewDomain,
      this.state.fileInfo?.fileId || this.state.shareOpenId,
      this.state.fileInfo?.domainId
    );
  }
  public codeCooldownCallback = (cooldownSeconds: number) => {
    if (cooldownSeconds > 0) {
      this.setState({
        validationBtnTxt: `${cooldownSeconds}秒后重新发送`,
        canGetCode: false,
      });
    } else {
      this.setState({
        validationBtnTxt: `获取验证码`,
        canGetCode: true,
      });
    }
  };
  public getCode = () => {
    const { mobileValue } = this.state;
    if (!validatePhone(mobileValue)) {
      message.warn('请输入正确的手机号');
      return;
    }
    resendSMSLoginCode({
      countryCode: '+86',
      mobilePhone: this.state.mobileValue,
      sendType: SMSSendType.SMS_LOGIN,
      verifyHeader: '',
    })
      .then((data: any) => {
        codeCooldown({
          timeTag: 'weboffive-mobile-timetag',
          cooldown: data.cooldown,
          callback: this.codeCooldownCallback,
        });
      })
      .catch((e) => {
        if (String(e.code) === '46001') {
          // 用户不存在 直接走注册用户跳过 获取token 然后再短信登录
          registerCodeRequest({
            countryCode: '+86',
            mobilePhone: this.state.mobileValue,
            verifyHeader: '',
          })
            .then((data: any) => {
              // 1.获取注册验证码
              codeCooldown({
                timeTag: 'qt-registry-timetag',
                cooldown: data.cooldown,
                callback: this.codeCooldownCallback,
              });
            })
            .then(() => {
              this.setState({
                currentMobileNotQtUser: false,
              });
            })
            .catch(() => {
              message.error('获取验证码失败');
            });
        } else if (String(e.code) === '48007') {
          message.error('当前手机号验证码获取已达上限，请使用轻推查看');
        } else {
          message.error('获取验证码失败');
        }
      });
  };
  public buildSmsButton = () => {
    const { canGetCode } = this.state;
    return (
      <div className="getcode-btn">
        <span
          className={canGetCode ? 'text' : 'text-none'}
          onClick={canGetCode ? this.getCode : undefined}
        >
          {this.state.validationBtnTxt}
        </span>
      </div>
    );
  };
  public smsLogin = () => {
    const { codeValue, mobileValue, currentMobileNotQtUser } = this.state;
    if (!validatePhone(mobileValue)) {
      message.warn('请输入正确的手机号');
      return;
    }
    if (codeValue && mobileValue) {
      this.setState({
        loading: true,
      });
      if (currentMobileNotQtUser) {
        // 轻推用户直接短信登录
        sms2Login({
          countryCode: '+86',
          phone: mobileValue,
          authCode: codeValue,
          verifyHeader: '',
        })
          .then((data: any) => {
            this.setState({
              loading: false,
            });
            const token = data.accessToken;
            const href = window.location.href;
            const redirectUrl = href + '?accessToken=' + token;
            const newUrl = redirectUrl;
            window.location.href = newUrl; // 登录成功打开分享页面
          })
          .catch((e: any) => {
            if (String(e.code) === '40001') {
              message.error('验证码错误');
            } else {
              message.error('系统繁忙，请稍后再试');
            }
            this.setState({
              loading: false,
            });
          });
      } else {
        // 非轻推用户走默认注册流程
        // 验证验证码 成功则进行默认用户注册的跳过操作
        registerCheckRequest({
          countryCode: '+86',
          validateCode: this.state.codeValue,
          mobilePhone: this.state.mobileValue,
        })
          .then(() => {
            // 注册用户
            // tslint:disable-next-line:no-identical-functions
            registerSkipStep('+86', this.state.mobileValue)
              .then((data: any) => {
                this.setState({
                  loading: false,
                });
                // 拿到token直接打开分享页面
                const token = data.accessToken;
                const href = window.location.href;
                const redirectUrl = href + '?accessToken=' + token;
                const newUrl = redirectUrl;
                window.location.href = newUrl; // 登录成功打开分享页面
              })
              .catch(() => {
                this.setState({
                  loading: false,
                });
                message.error('获取验证码失败');
              });
          })
          .catch((error: any) => {
            this.setState({
              loading: false,
            });
            if (String(error.code) === '40001') {
              message.error('验证码错误');
            } else {
              message.error('系统繁忙，请稍后再试');
            }
          });
      }
    }
  };

  render() {
    const isMobile = isMobileClient();
    const { fileInfo, fetchStatus, allowPreview, noPermission, notQtClient } = this.state;
    return (
      <div className="public-share">
        {isMobile ? (
          notQtClient && !getQuery('accessToken') && !getAccessToken() ? (
            <div className="mobile-tips-page">
              <img src={require('../../assets/pic.svg')} />
              <div className="tips">
                该文档需要进行身份信息验证才能访问
                {/* 请用<span className="highlight">「轻推」</span>打开此链接查看文件 */}
              </div>
              <div className="sms-form">
                <Input.Group size="default" compact className="mobile-input">
                  <Select defaultValue="+86" style={{ width: '20%' }}>
                    <Option value="+86">+86</Option>
                  </Select>
                  <Input
                    allowClear
                    value={this.state.mobileValue}
                    onChange={(e) => {
                      this.setState({
                        mobileValue: e.target.value,
                      });
                    }}
                    style={{ width: '48%', marginBottom: '20px', textAlign: 'left' }}
                    placeholder="请输入手机号"
                  />
                </Input.Group>
                <Input
                  value={this.state.codeValue}
                  onChange={(e) => {
                    this.setState({
                      codeValue: e.target.value,
                    });
                  }}
                  className="code-input"
                  placeholder="输入验证码"
                  suffix={this.buildSmsButton()}
                />
                <div>
                  <Button
                    loading={this.state.loading}
                    onClick={this.smsLogin}
                    disabled={!this.state.codeValue}
                    type="primary"
                    className={!this.state.codeValue ? 'disable-btn' : 'check-btn'}
                  >
                    查看文档
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <Mobile
              fileInfo={fileInfo}
              noPermission={noPermission}
              fetchStatus={fetchStatus}
              allowPreview={allowPreview}
              handleRetry={this.loadData}
              handleDownload={this.handleDownload}
              handlePreview={this.handlePreview}
            />
          )
        ) : (
          <PC
            fileInfo={fileInfo}
            noPermission={noPermission}
            fetchStatus={fetchStatus}
            allowPreview={allowPreview}
            handleRetry={this.loadData}
            handleDownload={this.handleDownload}
            handlePreview={this.handlePreview}
          />
        )}
      </div>
    );
  }
}
